// extracted by mini-css-extract-plugin
module.exports = {"checkboxGroup":"styles_checkboxGroup__MPxb8","label":"styles_label__11lhQ","checkboxGroupItems":"styles_checkboxGroupItems__2W443"};